import { Heart, Meh, Frown } from 'lucide-react';
import { PreferenceType } from '@/types/food';

export const PREFERENCE_CONFIG = {
  liked: {
    icon: Heart,
    label: 'Likte godt',
    color: 'text-green-600',
    bgColor: 'bg-green-50 border-green-200',
    emoji: '😍'
  },
  neutral: {
    icon: Meh,
    label: 'Nøytral',
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-50 border-yellow-200',
    emoji: '😐'
  },
  disliked: {
    icon: Frown,
    label: 'Likte ikke',
    color: 'text-red-600',
    bgColor: 'bg-red-50 border-red-200',
    emoji: '😞'
  }
} as const;

export const PREFERENCE_OPTIONS = [
  { value: 'liked', label: 'Likte godt 😍' },
  { value: 'neutral', label: 'Nøytral 😐' },
  { value: 'disliked', label: 'Likte ikke 😞' }
] as const;

export const TIMEFRAME_OPTIONS = [
  { value: 'all', label: 'Alle tider' },
  { value: 'week', label: 'Siste uke' },
  { value: 'month', label: 'Siste måned' },
  { value: 'three_months', label: 'Siste 3 måneder' }
] as const;